import api from "../../../../services/api";

import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import PublicationCard from "./components/PublicationCard";

import utils from "../../../../shared/utils";

import "./styles.css";

import imageIconArrow from "./images/icon-arrow.png";
import imageDefaultThumb from "./images/default_thumb.jpg";
// import imageMemorialThumb from "./images/memorial_thumb.jpg";

export default function PublicationsBlock() {
  const { accessType } = useParams();
  const [data, setData] = useState([
    {
      Titulo: "",
      Nome_Arquivo: "",
    },
    {
      Titulo: "",
      Nome_Arquivo: "",
    },
    {
      Titulo: "",
      Nome_Arquivo: "",
    },
    {
      Titulo: "",
      Nome_Arquivo: "",
    },
  ]);

  useEffect(() => {
    async function fetchData() {
      await api
        .get("/comunicados")
        .then((response) => {
          setData(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    fetchData();
  }, []);

  return (
    <div
      className="container"
      style={{ padding: "50px 15px 80px", marginTop: "0" }}
    >
      <div className="publicacoes_bloco">
        <div className="publicacoes_bloco--titulo">
          <div className="publicacoes_bloco--titulos">
            <h2>Comunicados</h2>
            <p>Confira os últimos comunicados do Crefito-2</p>
          </div>

          <div className="publicacoes_bloco--button">
            <Link className="button" to={`/${accessType}/comunicados`}>
              Ver mais Comunicados <img src={imageIconArrow} alt="" />
            </Link>
          </div>
        </div>

        <div className="row">
          {data.map((value, index) => (
            <PublicationCard
              key={index}
              imageThumb={
                value.Nome_Arquivo === null
                  ? imageDefaultThumb
                  : value.Nome_Arquivo
              }
              title={value.Titulo}
              href={`/${accessType}/conteudo/${utils.slugifyTitle(
                value.Titulo
              )}_${value.Codigo}`}
              button={"Ler tudo"}
            />
          ))}
          {/* <PublicationCard
            imageThumb={imageMemorialThumb}
            title="Memorial Crefito-2"
            href={`/${accessType}/memorial`}
            button={"Ver memorial"}
          /> */}
        </div>
      </div>
    </div>
  );
}
